import { post,get,del,put } from '@/utils/request'

// 新增轮播图
export function addBanner(data) {
  return post('/manage/banner', data)
}

// 获取轮播图列表
export function getBannerList() {
  return get('/banner')
} 

// 获取轮播图列表
export function deleteBanner(id) {
    return del(`/manage/banner/${id}`)
  } 
  
// 获取轮播图列表
export function updateBanner(id,data) {
    return put(`/manage/banner/${id}`,data)
  } 